import { render, staticRenderFns } from "./PhoneNumberField.vue?vue&type=template&id=3508eefc&scoped=true"
import script from "./PhoneNumberField.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberField.vue?vue&type=script&lang=ts"
import style0 from "./PhoneNumberField.vue?vue&type=style&index=0&id=3508eefc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3508eefc",
  null
  
)

export default component.exports